import type { FlatSurface, PlacementPosition, SizeMm, SurfacePoint } from '@repo/api-contracts';
import type { PhotoDimensions, PhotoRect } from '../types';

export const flatScale = (surface: FlatSurface, photo: PhotoDimensions): SurfacePoint => ({
  x: ((surface.points[1].x - surface.points[0].x) * photo.widthPx) / 100 / surface.realSize.widthMm,
  y:
    ((surface.points[3].y - surface.points[0].y) * photo.heightPx) /
    100 /
    surface.realSize.heightMm,
});

export const surfaceMmToPhoto = (
  surface: FlatSurface,
  photo: PhotoDimensions,
  point: PlacementPosition,
): SurfacePoint => {
  const scale = flatScale(surface, photo);
  return {
    x: (surface.points[0].x * photo.widthPx) / 100 + point.xMm * scale.x,
    y: (surface.points[0].y * photo.heightPx) / 100 + point.yMm * scale.y,
  };
};

export const photoToSurfaceMm = (
  surface: FlatSurface,
  photo: PhotoDimensions,
  point: SurfacePoint,
): PlacementPosition => {
  const scale = flatScale(surface, photo);
  return {
    xMm: (point.x - (surface.points[0].x * photo.widthPx) / 100) / scale.x,
    yMm: (point.y - (surface.points[0].y * photo.heightPx) / 100) / scale.y,
  };
};

export const componentRectOnPhoto = (
  surface: FlatSurface,
  photo: PhotoDimensions,
  component: SizeMm,
  position: PlacementPosition,
): PhotoRect => {
  const scale = flatScale(surface, photo);
  return {
    ...surfaceMmToPhoto(surface, photo, position),
    width: component.widthMm * scale.x,
    height: component.heightMm * scale.y,
  };
};
